export default __webpack_public_path__ + "static/media/enugugovt.4a9abc9c.webp";